import { BarChart } from "@mui/x-charts";
import { useData } from "../../context/DataProvider";
import "./index.scss";
import { useEffect, useMemo, useState } from "react";

const HotColdChart = (props: {scenario: string, period: string, led?: boolean}) => {
    const {hotColdData} = useData()!;
    const [hot, setHot] = useState<string>("0%");
    const [cold, setCold] = useState<string>("0%");
    useEffect(()=>{
        hotColdData?.filter((item)=>{
            return `${item.Scenario}` === props.scenario;
        })?.filter((filteredItem) => {
            return `${filteredItem.Period}` === props.period;
        })?.forEach((oneItem) => {
            setHot(`${(oneItem["`Hot Tank`"] * 100).toFixed(0)}%`);
            setCold(`${(oneItem["`Cold Tank`"] * 100).toFixed(0)}%`);
        })
    }, [props.scenario, props.period, hotColdData])

    
    return(<>
        {/*<BarChart 
        series={[{data: [hotColdSeries[0]], type: "bar"},{data: [hotColdSeries[1]]}]}
        yAxis={[{disableLine: true}, {fill: "#FFF"}, {max: 100}, {tickNumber: 5}]}
        height={300}
        disableAxisListener={true}
        colors={["#88B04F", "#203C5B"]}
        borderRadius={5}
        grid={{horizontal: true}}
    />*/}
        <div className={`simple-bar-chart ${props.led}`}>
            <div className="line-wrapper">
                <span>100%</span>
                <div />
            </div>
            <div className="line-wrapper">
                <span>75%</span>
                <div />
            </div>
            <div className="line-wrapper">
                <span>50%</span>
                <div />
            </div>
            <div className="line-wrapper">
                <span>25%</span>
                <div />
            </div>
            <div className="line-wrapper">
                <span>0%</span>
                <div />
            </div>
            <div className="tank-wrapper">
                <div className="hot-tank" style={{height: hot}}>
                    <span>{hot}</span>
                </div>
                <div className="cold-tank" style={{height: cold}}>
                    <span>{cold}</span>
                </div>
            </div>
            <div className="label-wrapper">
                <span>Hot Tank</span>
                <span>Cold Tank</span>
            </div>
        </div>
        </>
    )
}
export default HotColdChart;